export const cookies = {
	DURATION_ONE_YEAR: 31540000000,
	DURATION_ONE_MONTH: 2628000000,

	setCookie(key, value, time, path = '/', sameSite = 'Lax') {
		const COOKIE_DOMAIN = this.getCookieDomain();

		const expires = new Date();
		expires.setTime(expires.getTime() + time);

		// Build cookie parts as an object
		const cookieParts = {
			keyValue: `${key}=${value}`, // Encode value for safety
			path: `path=${path}`,
			domain: COOKIE_DOMAIN && `domain=${COOKIE_DOMAIN}`,
			expires: `expires=${expires.toUTCString()}`,
			sameSite: `SameSite=${sameSite}`,
			secure: 'Secure', // Always set Secure
		};

		try {
			// Join the parts into a cookie string
			document.cookie = Object.values(cookieParts)
				.filter(Boolean) // Remove empty or undefined values
				.join('; ');

			return true;
		} catch (e) {
			console.error('Failed to set cookie:', e);

			return false;
		}
	},

	/**
	 * Shared `.productive.io` domain on productive.io hosts, host-only cookie elsewhere (e.g. local `productive.test`).
	 */
	getCookieDomain() {
		const { hostname } = window.location;

		return hostname === 'productive.io' || hostname.endsWith('.productive.io') ? '.productive.io' : '';
	},

	getCookie(key) {
		let keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);

		return keyValue?.[2] ?? null;
	},
};
